import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, phoneMask } from '~/utils/masks';

export const HeaderReportDisapproved = [
  {
    id: 1,
    value: 'Nome',
    maxChar: 15,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 13,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Proposta',
    maxChar: 14,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Reprovação',
    maxChar: 14,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Operador(a) de Venda',
    maxChar: 12,
  },
  {
    id: 6,
    value: 'Usuário',
    maxChar: 10,
  },
  {
    id: 7,
    value: 'Celular',
    maxChar: 13,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Canal',
    maxChar: 9,
    textAlign: 'center',
  },
  {
    id: 9,
    value: 'Motivo',
    maxChar: 11,
  },
  {
    id: 10,
    value: 'Nacionalidade',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 11,
    value: 'FaceDoc',
    maxChar: 9,
    textAlign: 'center',
  },
];

export const BodyReportDisapproved = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 15,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 13,
        textAlign: 'center',
      },
      {
        value: i.dataProposta
          ? moment(i.dataProposta).format('DD/MM/YYYY HH:mm')
          : '',
        maxChar: 14,
        textAlign: 'center',
      },
      {
        value: i.dataReprovacao
          ? moment(i.dataReprovacao).format('DD/MM/YYYY HH:mm')
          : '',
        maxChar: 14,
        textAlign: 'center',
      },
      {
        value: i.operador,
        maxChar: 12,
      },
      {
        value: i.nomeUsuarioMesa,
        maxChar: 10,
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 13,
        textAlign: 'center',
      },
      {
        value: i.origem,
        maxChar: 9,
        textAlign: 'center',
      },
      {
        value: i.motivoReprovacao,
        maxChar: 11,
      },
      {
        value: i.nacionalidade ? i.nacionalidade : '-',
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.forceFaceMatch
          ? 'Ignorado'
          : i.faceMatchCheckResponse?.status
            ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
            i.faceMatchCheckResponse.status.slice(1).toLowerCase()
            : '-',
        maxChar: 9,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};

export const BodyReportDisapprovedCSV = (data: any) => {
  const dataCSV = [];

  data.pagina?.forEach((i) => {
    dataCSV.push({
      ...i,
      faceDoc: i.forceFaceMatch
        ? 'Ignorado'
        : i.faceMatchCheckResponse?.status
          ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
          i.faceMatchCheckResponse.status.slice(1).toLowerCase()
          : '-',
    });
  });

  return dataCSV;
};
